<template>
  <div class="dashboard">
    <div class="dashboard-content">
      <div class="dashboard-header" v-loading="loading.departments">

        <el-dropdown size="medium">
          <span class="el-dropdown-link">
             <h1 class="dashboard-content__title">{{ currentDepartment.title }}</h1><i
              class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="department of departmentList" :key="department.id">{{ department.title }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <date-picker v-model="currentDate" @change="getAppointmentsData"></date-picker>
      </div>

      <div class="top-panel">
        <el-radio-group v-model="currentTypeAppointment" class="departments-radio-group">
          <el-radio-button v-for="item in typeAppointment" :label="item.label" :key="item.label">
            {{ item.title }}
          </el-radio-button>
        </el-radio-group>
        <div class="counters" v-loading="loading.validationData">
          <div class="counters__value">{{ isToday ? 'Записи на сегодня' : 'Всего записей' }}
            <div class="counters__value_green">{{ validationData.amount }}</div>
          </div>
          <div class="counters__value">Требуют валидации
            <div class="counters__value_red">{{ validationData.needValidation }}</div>
          </div>
        </div>
      </div>

      <el-table
          :data="appointments"
          v-loading="loading.appointmentsData"
          class="zebra-table appointments"
          stripe
          style="width: 100%"
          :show-header="false">
        <el-table-column width="75">
          <template slot-scope="scope">
            <div class="procedure">
              <el-image class="procedure__icon" :src="scope.row.procedure.icon"></el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Клиент">
          <template slot-scope="scope">
            <div class="procedure">
              <span class="procedure__title">{{ scope.row.procedure.title }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Время визита">
          <template slot-scope="scope">
            {{ $root.timeIso(scope.row.start) }} - {{ $root.timeIso(scope.row.end) }}
          </template>
        </el-table-column>
        <el-table-column label="Сеанс">
              -
        </el-table-column>
        <el-table-column align="right">
          <template slot-scope="scope">
            <div class="user-data">
              <div class="user-data__name">{{ scope.row.user.name }}</div>
              <div class="user-data__phone">•• {{ scope.row.user.phone }}</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column width="50">
          <template slot-scope="scope">
            <el-tooltip v-if="scope.row.can_validated && !scope.row.validated"
                        content="Необходима валидация"
                        placement="top">
              <attention-icon/>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
          v-if="showPagination"
          class="pagination"
          background
          layout="prev, pager, next"
          :page-size="pagination.per_page"
          :total="pagination.total"
          :current-page="pagination.current_page"
          @current-change="editPage"
      />

      <div v-loading="loading.deviceInfo" class="status-bar">
        <div class="status-bar__title">
          <el-image style="width: 32px;" :src="cardioDeviceInfo.icon"></el-image>
          {{ cardioDeviceInfo.title }}
        </div>
        <div class="status-bar__number">{{ getCardioInfo('device_serial').value }}</div>
        <div class="status-bar__date">{{ $root.dateDefault(getCardioInfo('last_sync').value) }}
          {{ $root.timeIso(getCardioInfo('last_sync').value) }}
        </div>
        <div class="status-bar__charging">
          <battery-charging :batteryData="getCardioInfo('battery_level')"/>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import BatteryCharging from "@/components/dashboard/BatteryCharging"
import DatePicker from "@/components/ganttCalendar/DatePicker"
import AttentionIcon from "@/components/icons/Attention"

export default {
  name: "Dashboard.appointments",
  data: function () {
    return {
      loading: {
        departments: true,
        deviceInfo: true,
        validationData: true,
        appointmentsData: true,
      },
      currentDate: new Date(),
      currentDepartment: {},
      departmentList: [],
      appointments: [],
      pagination: [],
      cardioDeviceInfo: {},
      validationData: {},
      currentTypeAppointment: 'all',
      typeAppointment: [
        {
          label: 'all',
          title: 'Все записи',
        },
        {
          label: 'screening_plus',
          title: 'Скрининг плюс'
        }
      ],
    }
  },
  computed: {
    showPagination() {
      if (this.pagination) {
        return this.pagination.total > this.pagination.per_page
      } else return false
    },
    isToday() {
      return this.currentDate.toDateString() === new Date().toDateString()
    }
  },
  components: {
    BatteryCharging,
    DatePicker,
    AttentionIcon
  },
  watch: {
    currentTypeAppointment() {
      this.getAppointmentsData()
    }
  },
  created() {

  },
  mounted() {
    this.currentDate = new Date()

    this.getDepartments()
  },
  methods: {
    loadMainData() {
      this.getDeviceInfo()
      this.getAppointmentsData()
    },
    getDepartments() {
      this.loading.departments = true

      this.$api.session
          .getDepartments("lite")
          .then((response) => {
            this.departmentList = response.data
            this.currentDepartment = response.data[0]

            this.loadMainData()
          })
          .catch((response) => {
            this.$notify.error({
              title: "Ошибка загрузки списка центров 😕",
              message: response.response.data.message,
            })
          })
          .finally(() => {
            this.loading.departments = false
          })
    },
    getCardioInfo(param) {
      if (!this.cardioDeviceInfo.info) return {}
      return this.cardioDeviceInfo.info.find(item => item.code === param)
    },
    editPage(page) {
      this.getAppointmentsData(this.currentDate, page)
    },
    getAppointmentsData(date, page = 1) {
      this.loading.validationData = true
      this.loading.appointmentsData = true

      let payload = {
        params: {
          departments: [this.currentDepartment.id],
          calendar_date: date ? date : this.$root.dateBack(this.currentDate),
          type: this.currentTypeAppointment,
          limit: 10,
          page: page
        }
      }

      this.$api.dashboard
          .getAppointmentsData(payload)
          .then((response) => {
            this.appointments = response.data.data
            this.pagination = response.data.meta.pagination
          })
          .catch((response) => {
            this.$notify.error({
              title: "Ошибка загрузки записей 😕",
              message: response.response.data.message,
            })
          })
          .finally(() => {
            this.loading.appointmentsData = false
            this.getValidationData()
          })
    },
    getValidationData() {
      this.loading.validationData = true

      let payload = {
        params: {
          departments: [this.currentDepartment.id],
          calendar_date: this.$root.dateBack(this.currentDate),
          type: this.currentTypeAppointment,
        }
      }

      this.$api.dashboard
          .getValidationData(payload)
          .then((response) => {
            this.validationData = response.data.data
          })
          .catch((response) => {
            this.$notify.error({
              title: "Ошибка загрузки счетчиков записей 😕",
              message: response.response.data.message,
            })
          })
          .finally(() => {
            this.loading.validationData = false
          })
    },

    getDeviceInfo() {
      this.loading.deviceInfo = true

      this.$api.dashboard
          .getDeviceInfo(this.departmentList[0].id)
          .then((response) => {
            this.cardioDeviceInfo = response.data

          })
          .catch((response) => {
            this.$notify.error({
              title: "Ошибка загрузки данных о приборе 😕",
              message: response.response.data.message,
            })
          })
          .finally(() => {
            this.loading.deviceInfo = false
          })
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/zebra-table.scss";

.zebra-table {
  margin-top: 20px;

  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 16px;
  color: #676767;

  /deep/ .el-table__row {
    height: 60px;
  }
}

.procedure {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 22px;

  &__title {
    font-weight: 600;
    font-size: 15px;
    line-height: 16px;
    color: #111;
  }

  &__icon {
    width: 32px;
    max-height: 32px;
  }
}

.user-data {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;

  &__name {
    color: #676767;
  }

  &__phone {
    color: #111111;
  }
}

.dashboard {
  margin-top: 50px;
  width: 100%;
}

.dashboard-content {
  box-sizing: border-box;
  overflow: hidden;
  padding: 0 72px;

  max-width: 1200px;
  margin: 16px auto;

  &__title {
    margin: 0;
    padding: 0;

    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 26px;
    color: #111;
  }

  &__sub-title {
    margin: 32px 0 16px 0;
    padding: 0;

    font-weight: 500;
    font-size: 13px;
    line-height: 16px;
    color: #111;
  }
}

.top-panel {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.counters {
  display: flex;
  align-items: center;
  justify-content: space-between;

  &__value {
    margin-left: 16px;

    display: flex;
    align-items: center;
    justify-content: space-between;

    font-size: 14px;
    line-height: 16px;

    letter-spacing: -0.005em;
    color: #676767;

    &_red {
      color: #E06161;
    }

    &_green {
      color: #43D3B3;
    }

    div {
      margin-left: 6px;

      font-weight: 500;
      font-size: 14px;
      line-height: 16px;
    }
  }
}

.status-bar {
  padding: 30px 0;
  border-top: 1px solid #EAEAEA;

  display: flex;
  align-content: space-between;
  align-items: center;
  justify-content: flex-end;

  position: absolute;
  bottom: 0;
  width: calc(100% - 144px);
  max-width: 1056px;

  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 16px;
  color: #111;

  gap: 35px;

  & > div {
    margin: 0 10px 0 0;
  }

  & > div:nth-child(4n) {
    margin-right: 0;
  }

  &__title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 15px;

    font-weight: 600;
    font-size: 15px;
    line-height: 16px;
  }
}

.departments-radio-group {
  margin: 13px 0;
}

.dashboard-header {
  margin: 16px auto;
  display: flex;
  align-items: center;
}


.el-dropdown-link {
  display: flex;
  align-items: center;
}

/deep/ th.is-leaf, td {
  padding: 14px 0 !important;
  border-bottom: none;
}
</style>
